import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import H5 from '@base/H5/H5';
import LanguageDropdown from '@comp/Question/LanguageDropdown';
import { setModalState } from '@actions/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getQuestion } from '@selectors/quizTaking';
import { Spacings, Fonts } from '@styles/index';
import ReportButton from '@cont/Quiz/Taking/Common/ReportButton';
import { useToggleable } from '@stores/toggleables';
import { MODAL_TYPES } from '../../constants';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${Spacings.SPACING_4B};
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  color: var(--color-text-primary);
`;

const HeaderActionWrapper = styled.div`
  height: ${Spacings.SPACING_6B};
  margin-left: ${Spacings.SPACING_5B};
  display: flex;
`;

const Flex = styled.div`
  display: flex;
`;

const Score = styled.div`
  border-radius: ${Spacings.SPACING_1B};
  padding: 0 ${Spacings.SPACING_2B};
  height: ${Spacings.SPACING_6B};
  background-color: var(--color-base-light-0);
  margin: 0 0 0 ${Spacings.SPACING_1B};
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-i-black);
  font-size: ${Fonts.ULTRA_SMALL};
`;

const ScoreWrapper = styled.div`
  display: flex;
  margin-left: ${Spacings.SPACING_3B};
`;

const QuestionHeader = ({
  sectionUID,
  questionUID,
  currentLanguage,
  availableLanguages,
  onLanguageChange
}) => {
  const dispatch = useDispatch();

  const currentQuestion = useSelectorWithShallowEqual(
    getQuestion(sectionUID, questionUID)
  );
  const { openElement: openReportDrawer } = useToggleable(
    MODAL_TYPES.QUIZ_REPORT_QUESTION
  );

  const handleOnReportClick = () => {
    openReportDrawer();
    dispatch(
      setModalState({
        type: 'Report Question',
        data: {
          questionUID
        }
      })
    );
  };

  const shouldShowLanguageOption = availableLanguages.length > 1;

  return (
    <>
      <Wrapper>
        <Flex>
          <H5>{`Q${currentQuestion.question_rank}`}</H5>
          <ScoreWrapper>
            <Score>+{currentQuestion.positive_score}</Score>
            <Score>-{currentQuestion.negative_score}</Score>
          </ScoreWrapper>
        </Flex>
        <HeaderActions>
          {shouldShowLanguageOption && (
            <HeaderActionWrapper>
              <LanguageDropdown
                options={availableLanguages}
                selectedOption={currentLanguage}
                onLanguageChange={onLanguageChange}
              />
            </HeaderActionWrapper>
          )}
          <HeaderActionWrapper>
            <ReportButton onClick={handleOnReportClick} />
          </HeaderActionWrapper>
        </HeaderActions>
      </Wrapper>
    </>
  );
};

export default QuestionHeader;

QuestionHeader.propTypes = {
  sectionUID: PropTypes.string.isRequired,
  questionUID: PropTypes.string.isRequired,
  currentLanguage: PropTypes.objectOf(PropTypes.any).isRequired,
  onLanguageChange: PropTypes.func.isRequired
};
